import { createContext } from 'react';
import { createStoreContext } from 'ariakit-utils/store';
var ComboboxContext = createStoreContext();
var ComboboxItemValueContext = /*#__PURE__*/createContext(undefined);
export { ComboboxContext as C, ComboboxItemValueContext as a };